var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/**
 * API services for Template creation from proposals
 */
import api from '@utils/axios';
/**
 * Creates a template from a proposal
 * @param proposalId - The proposal ID to create template from
 * @param templateData - The template creation data
 * @returns Promise with the template creation result
 */
export function createTemplate(proposalId, templateData) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const response = yield api.post(`/api/internal/proposals/${proposalId}/create_template`, {
                template: templateData
            });
            return response.data;
        }
        catch (error) {
            console.error('Error creating template:', error);
            throw error;
        }
    });
}
